/**
 * Reads + validates `import.meta.env` at module-load time.
 * Throws if a required variable is missing — fails fast in dev and at build time.
 */

function readRequired(name: string, value: string | undefined): string {
  if (value === undefined || value === '') {
    throw new Error(
      `[env.config] Missing required environment variable: ${name}. Copy .env.example to .env.local and set it.`,
    );
  }
  return value;
}

export const env = {
  apiBaseUrl: readRequired('VITE_API_BASE_URL', import.meta.env['VITE_API_BASE_URL']),
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export type Env = typeof env;
